<tt-page *ngIf="!!setting">
    <div class="height-full" *ngIf="'mobile' | mediaQuery">
        <tt-page-heading *ngIf="!!setting.purch_heading" [ttModel]="setting.purch_heading"></tt-page-heading>

        <tt-card class="col-xs-12 sp-0">
            <tt-input ttLabel="purch_internal_no" [ttModel]="setting.purch_internal_no" ttReadonly></tt-input>
            <tt-input ttLabel="supplier_no" [ttModel]="setting.supplier_no" ttReadonly></tt-input>
            <tt-select ttLabel="purchrequestcreate_std_supplier_no" [(ttModel)]="setting.supplier_no" [ttData]="selectListSuppliers" ttDataId="supplier_no" ttDataName="supplier_name"></tt-select>
            <tt-button-save *ngIf="setting.supplier_no !== '0'" ttText="purchrequestcreate_create" (ttClick)="createChanges()" [ttLoading]="creating"></tt-button-save>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1 height-full" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-page-heading *ngIf="!!setting.purch_heading" [ttModel]="setting.purch_heading"></tt-page-heading>

        <tt-divider ttRememberId="purchrequestcreate_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 sp-0">
                        <tt-input ttLabel="purch_internal_no" [ttModel]="setting.purch_internal_no" ttReadonly></tt-input>
                        <tt-input ttLabel="supplier_no" [ttModel]="setting.supplier_no" ttReadonly></tt-input>
                        <tt-select ttLabel="purchrequestcreate_std_supplier_no" [(ttModel)]="setting.supplier_no" [ttData]="selectListSuppliers" ttDataId="supplier_no" ttDataName="supplier_name"></tt-select>
                        <tt-button-save *ngIf="setting.supplier_no !== '0'" ttText="purchrequestcreate_create" (ttClick)="createChanges()" [ttLoading]="creating"></tt-button-save>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-grid *ngIf="!!grid" class="flex-1 height-full" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
